import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { OrderInsightsPageRoutingModule } from './order-insights-routing.module';
import { OrderInsightsPage } from './order-insights.page';
import { SharedModule } from '@shared/shared.module';
import { OrderInsightsProductTabletComponent } from '@order/components/order-insights/order-insights-product-tablet/order-insights-product-tablet.component';
import { OrderInsightsProductDesktopComponent } from '@order/components/order-insights/order-insights-product-desktop/order-insights-product-desktop.component';
import { OrderInsightsProductMobileComponent } from '@order/components/order-insights/order-insights-product-mobile/order-insights-product-mobile.component';
import { ProgressBarComponent } from '@order/components/order-insights/progress-bar/progress-bar.component';
import { OrderPercentagesBarComponent } from '@shared/components/order-percentages-bar/order-percentages-bar.component';
import { OrderInsightsPageHeaderComponent } from '@order/components/order-insights/order-insights-page-header/order-insights-page-header.component';
import { SharedProductModule } from '@app/shared-product/shared-product.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    OrderInsightsPageRoutingModule,
    SharedModule,
    SharedProductModule,
  ],
  declarations: [
    OrderInsightsPage,
    OrderPercentagesBarComponent,
    OrderInsightsProductDesktopComponent,
    OrderInsightsProductTabletComponent,
    OrderInsightsProductMobileComponent,
    ProgressBarComponent,
    OrderInsightsPageHeaderComponent,
  ],
})
export class OrderInsightsPageModule {}
